// Polyfills for Node.js globals in the browser environment
window.global = window;
window.process = window.process || {};
window.process.env = window.process.env || {};
